/**
 * Matches double brackets and captures the text inside
 */
export const DOUBLE_BRACKET_REGEX = new RegExp(/\[\[(.*?)]]/g);
